import React from 'react';
import { useCompanyBranding } from '../../hooks';
import { Banner as BannerModel } from '../../models';
import HomeTextBannerAllies from './homeParagraphs/HomeTextBannerAllies';
import HomeButtonBannerAllies from './homeButtons/HomeButtonBannerAllies';

export default function BannerAllies() {
  const [companyBrandingInfo, setcompanyBrandingInfo] =
    React.useState<BannerModel>(null);
  const [companyBranding] = useCompanyBranding();

  React.useEffect(() => {
    if (!companyBranding) return;
    const bannerItem = companyBranding?.banners?.find(
      (banner: BannerModel) => banner.seccion === 'final'
    );
    if (bannerItem) {
      setcompanyBrandingInfo(bannerItem);
    }
  }, [companyBranding]);
  return (
    <div className="relative overflow-hidden">
      <div className="relative p-5 md:p-10 lg:p-20">
        <div className=" w-full h-full flex flex-col p-5">
          <div className="flex flex-row gap-1">
            <p className="text-xl lg:text-2xl text-color-primary-text-300 font-semibold inline-block align-baseline pt-5 px-5 pb-4 lg:px-10 lg:pl-16">
              {companyBrandingInfo?.title !== ''
                ? '¿CLIENTES O ALIADOS? ¿AMBOS?'
                : companyBrandingInfo?.title}
            </p>
          </div>
          <div className="flex flex-col lg:flex-row">
            <HomeTextBannerAllies text={companyBrandingInfo?.text} />
            <div className="flex flex-col gap-5 justify-end px-5 pb-8 mt-10 xl:pl-20">
              <div className="flex flex-col gap-5 ">
                <HomeButtonBannerAllies
                  buttonsArray={companyBrandingInfo?.buttons}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
